import { render, staticRenderFns } from "./AdminVideos.vue?vue&type=template&id=0a3c8276&"
import script from "./AdminVideos.vue?vue&type=script&lang=ts&"
export * from "./AdminVideos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports